/*
 * Root reducer
 */ import combineReducers from "../utils/combineReducers";
import lpsReducer from "./lpsReducer";
import localizationReducer from "./localizationReducer";
var rootReducer = combineReducers({
    lps: lpsReducer,
    localization: localizationReducer
});
export default rootReducer;

//# sourceMappingURL=index.js.map